module.exports = __webpack_public_path__ + "static/img/celoscope-detail-4.03ad462.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-4.jpg
// module id = fziA
// module chunks = 51